/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_View_ClaimantsInputs */

const en_gift_view_claimants = /** @type {(inputs: Gift_View_ClaimantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Claimants`)
};

const es_gift_view_claimants = /** @type {(inputs: Gift_View_ClaimantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver Reclamantes`)
};

const fr_gift_view_claimants = /** @type {(inputs: Gift_View_ClaimantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir les réclamants`)
};

const de_gift_view_claimants = /** @type {(inputs: Gift_View_ClaimantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einlöser ansehen`)
};

const id_gift_view_claimants = /** @type {(inputs: Gift_View_ClaimantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Pengklaim`)
};

/** @type {(inputs: Gift_View_ClaimantsInputs) => LocalizedString} */
const ja_gift_view_claimants = en_gift_view_claimants;

/** @type {(inputs: Gift_View_ClaimantsInputs) => LocalizedString} */
const zh_gift_view_claimants = en_gift_view_claimants;

/** @type {(inputs: Gift_View_ClaimantsInputs) => LocalizedString} */
const ar_gift_view_claimants = en_gift_view_claimants;

/** @type {(inputs: Gift_View_ClaimantsInputs) => LocalizedString} */
const it_gift_view_claimants = en_gift_view_claimants;

/** @type {(inputs: Gift_View_ClaimantsInputs) => LocalizedString} */
const ru_gift_view_claimants = en_gift_view_claimants;

/** @type {(inputs: Gift_View_ClaimantsInputs) => LocalizedString} */
const pt_gift_view_claimants = en_gift_view_claimants;

/** @type {(inputs: Gift_View_ClaimantsInputs) => LocalizedString} */
const ko_gift_view_claimants = en_gift_view_claimants;

/**
* | output |
* | --- |
* | "View Claimants" |
*
* @param {Gift_View_ClaimantsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const gift_view_claimants = /** @type {((inputs?: Gift_View_ClaimantsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_View_ClaimantsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gift_view_claimants(inputs)
	if (locale === "es") return es_gift_view_claimants(inputs)
	if (locale === "fr") return fr_gift_view_claimants(inputs)
	if (locale === "de") return de_gift_view_claimants(inputs)
	if (locale === "ja") return ja_gift_view_claimants(inputs)
	if (locale === "zh") return zh_gift_view_claimants(inputs)
	if (locale === "ar") return ar_gift_view_claimants(inputs)
	if (locale === "id") return id_gift_view_claimants(inputs)
	if (locale === "it") return it_gift_view_claimants(inputs)
	if (locale === "ru") return ru_gift_view_claimants(inputs)
	if (locale === "pt") return pt_gift_view_claimants(inputs)
	return ko_gift_view_claimants(inputs)
});